import { render, staticRenderFns } from "./LocalUploadArquive.vue?vue&type=template&id=2163bcf2&scoped=true"
import script from "./LocalUploadArquive.vue?vue&type=script&lang=js"
export * from "./LocalUploadArquive.vue?vue&type=script&lang=js"
import style0 from "./LocalUploadArquive.vue?vue&type=style&index=0&id=2163bcf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2163bcf2",
  null
  
)

export default component.exports